import { useYwuApp } from '../../../contexts/ywu-app-context';
import { Domicile } from '../../../enums';
import { getDefaultDomicileIsoAlpha2 } from '../../../utils/utils';
import { useClient } from '../../client-api';
import { useEnabledDomiciles } from '../../domicile-api';

export function useActiveDomicile() {
    const { data: activeClient } = useClient();
    const { data: enabledDomiciles } = useEnabledDomiciles();
    const { activeDomicile } = useYwuApp();

    if (activeClient) {
        return enabledDomiciles?.find((domicile) => domicile.isoAlpha2 === activeClient?.mainDomicile?.countryCode)?.isoAlpha2 ?? Domicile.GLOBAL;
    } else {
        return activeDomicile || getDefaultDomicileIsoAlpha2(enabledDomiciles ?? []);
    }
}
